<mat-nav-list class="p-0">
  @for (item of menuItems(); track item) {
  <a class="menu-item" mat-list-item [routerLink]="item.route" (click)="toggleSubmenu(item)"
    routerLinkActive="selected-menu-item">
    <div class="d-flex justify-content-start align-items-center">
      <mat-icon matListItemIcon><span>{{ item.icon }}</span></mat-icon>
      <span>{{ item.label | translate }}</span>
      @if (item.submenu && item.submenu.length > 0) {
      <mat-icon>{{ isSubmenuOpen(item) ? 'expand_less' : 'expand_more' }}</mat-icon>
      }
    </div>
  </a>
  @if (isSubmenuOpen(item)) {
  <mat-list class="p-0">
    @for (subItem of item.submenu; track subItem) {
    <a mat-list-item [routerLink]="subItem.route" routerLinkActive="selected-menu-item" class="menu-item ms-3">
      <div class="d-flex align-items-center justify-content-start">
        <mat-icon matListIcon class="pt-1 fs-6">{{ subItem.icon }}</mat-icon>
        <span>{{ subItem.label | translate }}</span>
      </div>
    </a>
    }
  </mat-list>
  }
  }
</mat-nav-list>